<template>
     <div class="spSelectModal user-warp" :class="{ active: isShow}">
        <div class="user-warp-bg" @click="onClose"></div>
        <div class="user-warp-content">
            <img src="https://resource.rcclchina.com.cn/birthday/arrow.png" alt="" class="triangle">
            <div class="user-title">
                一份生日礼遇收费300元；每舱<span>最多预订2份</span>，收费400元（此情况下，仅神秘生日礼物和小寿星挂牌<span>各提供2份</span>
                ，其余三项礼遇<span>各提供1份</span>，需确认<span>同一用餐时间</span>享用生日蛋糕）；用餐前请告知餐厅服务生。
            </div>
            <div class="sp-item">
                <div class="sp-item-title">选择乘客</div>
                <div class="sp-item-content">
                    <div class="sp-item-option" v-for="(guest, i) in specialBookingGuests" :key="('guest_'+i)"
                    :class="{ active: isGuestSelectedSp(guest)}"
                    @click="onGuestSelected(guest)">
                        <div class="sp-item-name">{{getGuestName(guest, i)}}</div>
                        <div class="user-other-info">
                            <span>{{guest.gender == 'M' ? '男': '女'}}</span>
                            <span class="splite">|</span>
                            <span class="birthday">{{guest.birthDate}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sp-item">
                <div class="sp-item-title">选择用餐日期</div>
                <div class="sp-item-content">
                    <div class="sp-item-option" v-for="(date, i) in mealDates" :key="('mealInfo_'+i)"
                        :class="{ active: selectedDate == date}"
                        @click="onDateClick(date)">
                        <div class="sp-item-name sp-item-center">
                            <span>{{getDate(date)}}</span>
                            <span style="margin-left: 10px;">{{getDay(i)}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sp-item">
                <div class="sp-item-title">选择用餐时间</div>
                <div class="sp-item-content">
                    <div class="sp-item-option" v-for="(timeslot, i) in mealTimeslots" :key="('timeslot_'+i)"
                        :class="{ active: selectedTimeslot == timeslot.mealTimeType, disable: isTimeslotDisable(timeslot)}"
                        @click="onTimeslotClick(timeslot)">
                        <div class="sp-item-name sp-item-center">
                            {{mealPlace.mealPlace}}·{{timeslot.mealTime}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sp-buttons">
            <div class="sp-button closeBtn" @click="onRemoveAllSelected">暂不选择</div>
            <div class="sp-button confirmBtn" @click="submitSp"
            :class="{ active: checkSubmtData().length == 0}">确认</div>
        </div>
    </div>
</template>

<script>
import { numberToChinese } from '@/utilities/tools'
import { SpecialBookingType } from '@/utilities/specialBookingHelper'
import _ from 'lodash'
import api from '@/api'
export default {
    name: "GuestInfoSpecialBookingSelect",
    props: {
        isShow: {
            type: Boolean
        },
        guests: {
            type: Array,
            default() {
                return []
            }
        },
        couponCode: {
            type: String
        },
        sessionToken: {
            type: String
        },
        specialBooking: {
            type: Object,
            default() {
                return {}
            }
        },
        mealInfoViews: {
            type: Array,
            default () {
                return []
            }
        },
        onClose: {
            type: Function
        }
    },
    data () {
        return {
            specialBookingGuests: [],
            selectedDate: '',
            selectedTimeslot: 0
        }
    },
    mounted () {
        this.initSpecialBookingGuests()
    },
    methods: {
        initSpecialBookingGuests () {
            this.selectedDate = ''
            this.selectedTimeslot = 0
            this.specialBookingGuests = []
            if (this.guests && this.guests.length > 0) {
                this.guests.forEach(guest=> {
                    this.specialBookingGuests.push({
                        lastName: guest.lastName,
                        firstName: guest.firstName,
                        pyLastName: guest.pyLastName,
                        pyFirstName: guest.pyFirstName,
                        birthDate: guest.birthDate,
                        gender: guest.gender,
                        specialBookingOrder: guest.specialBookingOrder
                    })
                    if (this.isGuestSelectedSp(guest)) {
                        this.selectedDate = guest.specialBookingOrder.specialBookingDate
                        this.selectedTimeslot = guest.specialBookingOrder.specialBookingTimeslot
                    }
                })
            }
        },
        // 最多选2个
        isGuestDisable () {
            return this.selectedGuests.length >= 2
        },
        getGuestName(guest, i) {
            let name = guest.lastName + guest.firstName
            if (!name || name.trim().length == 0) {
                name = `${guest.pyLastName} ${guest.pyFirstName}`
                if (!name || name.trim().length == 0) {
                    name = `乘客${i+1}`
                }
            }
            return name
        },
        isGuestSelectedSp(guest) {
            return guest.specialBookingOrder && 
            guest.specialBookingOrder.specialBookingType == this.specialBooking.specialBookingType
        },
        onGuestSelected(guest) {
            if (this.isGuestSelectedSp(guest)) {
                guest.specialBookingOrder = null
            } else {
                // 最多选两个人，如果选3个人，第一个人反选
                if (this.isGuestDisable()) {
                    let selectedGuests = _.orderBy(this.selectedGuests, 'specialBookingOrder.selectTime')
                    if (selectedGuests && selectedGuests.length > 0) {
                        selectedGuests[0].specialBookingOrder = null
                    }
                }
                guest.specialBookingOrder = {
                    specialBookingType: this.specialBooking.specialBookingType,
                    specialBookingPlace: this.mealPlace.mealPlaceType, // 主餐厅默认写死
                    specialBookingTimeslot: this.selectedTimeslot,
                    specialBookingCodes: this.specialBooking.optionCodes,
                    specialBookingDate: this.selectedDate,
                    selectTime: (Date.now())
                }
            }
        },
        getDate (date) {
            if (date && date.length == 10) {
                return date.substr(5, 5)
            }
            return date;
        },
        getDay (i) {
            return `第${numberToChinese(i+1)}天`
        },
        onDateClick (date) {
            if (this.selectedDate == date) {
                this.selectedDate = ''
            } else {
                this.selectedDate = date
                // 第一天不能选午餐。如果之前选择了午餐，日期又选了第一天，需要把午餐反选
                if (this.selectedTimeslot == 1) {
                    let index = this.mealDates.indexOf(this.selectedDate)
                    if (index == 0) {
                        this.selectedTimeslot = 0
                    }
                }
            }
        },
        // 第一天不能选午餐
        isTimeslotDisable (timeslot) {
            if (timeslot.mealTimeType == 2) return false
            if (this.selectedDate && this.selectedDate.length > 0) {
                let index = this.mealDates.indexOf(this.selectedDate)
                if (index == 0) return true
            }
            return false
        },
        onTimeslotClick (timeslot) {
            if (this.selectedTimeslot == timeslot.mealTimeType) {
                this.selectedTimeslot = 0
            } else {
                if (this.isTimeslotDisable(timeslot)) return
                this.selectedTimeslot = timeslot.mealTimeType
            }
        },
        checkSubmtData () {
            let errors = []
            let guestCount = this.selectedGuests.length
            if (guestCount == 0) {
                errors.push('请选择乘客！')
            }
            else if (guestCount > 2) {
                errors.push('最多可选择2位乘客！')
            }
            if (!this.selectedDate || this.selectedDate.length == 0) {
                errors.push('请选择享用蛋糕日期！')
            }
            if (this.selectedTimeslot == 0) {
                errors.push('请选择享用蛋糕时间！')
            }
            return errors
        },
        submitSp() {
            const errors = this.checkSubmtData()
            if (errors.length > 0) {
                this.$alert.show(errors[0])
                return
            }
            let submitGuests = []
            this.specialBookingGuests.forEach(guest=> {
                if (this.isGuestSelectedSp(guest)) {
                    guest.specialBookingOrder.specialBookingPlace = this.mealPlace.mealPlaceType, // 主餐厅默认写死
                    guest.specialBookingOrder.specialBookingTimeslot = this.selectedTimeslot,
                    guest.specialBookingOrder.specialBookingCodes = this.specialBooking.optionCodes,
                    guest.specialBookingOrder.specialBookingDate = this.selectedDate
                    submitGuests.push(guest)
                }
            })
            let guests = [...this.guests]
            guests.forEach(guest=> {
                let submitGuest = submitGuests.find(r=>r.pyLastName==guest.pyLastName
                && r.pyFirstName==guest.pyFirstName
                && r.birthDate==guest.birthDate)
                if (submitGuest) {
                    guest.specialBookingOrder = submitGuest.specialBookingOrder
                } else {
                    guest.specialBookingOrder = null
                }
            })
            this.onSpecialBookingSubmit(guests)
        },
        async onSpecialBookingSubmit(guests) {
            
            let requestData = {
                bookingKey: this.bookingKey,
                token: this.sessionToken,
                guests: {
                    guestPersons: guests
                },
                couponCode: this.couponCode
            }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.updateSpecialBooking(requestData)
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
                return
            } 
            if (data && data.model && data.model.bookings) {
                let order = this.order
                order.bookings = data.model.bookings
                this.$store.commit('SET_BOOKING_FUNNEL_ORDER', order)
            }
            this.onClose()
        },
        async onRemoveAllSelected() {
            let guests = [...this.guests]
            guests.forEach(guest=> {
                guest.specialBookingOrder = null
            })
            await this.onSpecialBookingSubmit(guests)
        }
    },
    computed: {
        order () {
            return this.$store.state.booking.order
        },
        bookingKey () {
            return this.$store.state.booking.bookingKey
        },
        mealDates () {
            let mealDates = []
            this.mealInfoViews.map(r=>r.mealDate).forEach(date => {
                if (!mealDates.some(r=>r == date)) {
                    mealDates.push(date)
                }
            })
            return mealDates
        },
        mealTimeslots () {
            let mealTimeslots = []
            this.mealInfoViews.forEach(mealInfo => {
                if (!mealTimeslots.some(r=> r.mealTime == mealInfo.mealTime && r.mealTimeType == mealInfo.mealTimeType)) {
                    mealTimeslots.push({
                        mealTime: mealInfo.mealTime,
                        mealTimeType: mealInfo.mealTimeType
                    })
                }
            })
            return _.orderBy(mealTimeslots, 'mealTimeType')
        },
        mealPlace () {
            if (this.mealInfoViews.length > 0) {
                return {
                    mealPlace: this.mealInfoViews[0].mealPlace,
                    mealPlaceType: this.mealInfoViews[0].mealPlaceType
                }
            } else {
                return {
                    mealPlace: '',
                    mealPlaceType: 0
                }
            }
        },
        selectedGuests () {
            return this.specialBookingGuests
                .filter(r=>r.specialBookingOrder 
                && r.specialBookingOrder.specialBookingType == this.specialBooking.specialBookingType)
        },
        isBirthday () {
            return this.specialBooking.specialBookingType == SpecialBookingType.Birthday
        }
    },
    watch: {
        isShow (newOne) {
            if (newOne) {
                // 新弹出选择框后，重新从guest中查看特别礼遇选择情况
                this.initSpecialBookingGuests()
            }
        },
        specialBookingType (newOne, oldOne) {
            // 如果切换特别礼遇，之前选择的内容清空
            if (newOne && oldOne && newOne.specialBookingType > 0 && oldOne.specialBookingType > 0
            && newOne.specialBookingType != oldOne.specialBookingType) {
                this.selectedDate = ''
                this.selectedTimeslot = ''
            }
        }
    }
}
</script>


<style lang="less" scoped>
@black: #282b2c;

.user-warp {
    position: absolute;
    top: 56px;
    right: 3px;
    width: 580px;
    background-color: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(46, 65, 80, 0.17);
    z-index: 5;

    .user-warp-bg {
        position: fixed;
        z-index: 4;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .user-warp-content {
        position: relative;
        z-index: 5;
        height: 100%;
        .triangle {
            position: absolute;
            top: -15px;
            right: 20px;
            width: 19px;
        }
        .user-title {
            margin: 0px 3px 0px 15px;
            color: @black;
            font-size: 12px;
            font-weight: 600;
            padding: 15px 0px;
            border-bottom: solid 1px #d3dadd;
            letter-spacing: 2px;
            span {
                color: #e20101;
            }
        }
        .sp-item {
            margin: 10px 0px 0px 15px;
            .sp-item-title {
                color: @black;
                font-size: 14px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .sp-item-content {
                margin-left: 8px;
                .sp-item-option {
                    position: relative;
                    padding: 5px 10px;
                    width: 130px;
                    max-width: 130px;
                    margin-right: 8px;
                    margin-bottom: 10px;
                    background-color: #ffffff;
                    border: solid 1px #d3dadd;
                    display: inline-block;
                    cursor: pointer;
                    color: #727e81;
                    font-weight: 500;
                    .sp-item-name {
                        font-size: 14px;
                        letter-spacing: 1px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        &.sp-item-center {
                            text-align: center;
                        }
                    }
                    .user-other-info {
                        font-size: 12px;
                        color: #a5afb3;
                        margin-top: 3px;
                        .splite {
                            margin: 0px 5px;
                        }
                    }
                    &.active {
                        background-image: linear-gradient( #e7f5ff, #e7f5ff), linear-gradient( #ffffff, #ffffff);
                        background-blend-mode: normal, normal;
                        border: solid 1px #006ab9;
                        color: #006ab9;
                        .user-other-info {
                            color: #006ab9;
                        }
                    }
                    &.disable {
                        background: #f8f8f8;
                        border-color: #f8f8f8;
                        color: #c8c8c8;
                        cursor: not-allowed;
                    }
                }
            }
            
        }
    }

    .sp-buttons {
        position: relative;
        z-index: 5;
        background: #f5f5f5;
        height: 50px;
        text-align: center;
        .sp-button {
            width: 80px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
            vertical-align: middle;
            margin-top: 10px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            &.closeBtn {
                color: @black;
                background: #fff;
                margin-right: 10px;
            }
            &.confirmBtn {
                color: white;
                background: #0064bc;
            }
        }
    }
}
</style>

